<div class="ai-token-modal">
  <div class="logo-container">
    <img src="assets/images/brand/worldtumbler-on-dark.svg" alt="WorldTumbler" class="main-logo">
  </div>

  <h2 class="modal-title">{{modalTitle}} Generation</h2>

  @if (modalTitle?.toLowerCase() !== 'content') {
    <p class="description">
      The more information you add to your character sheet, the more detailed and accurate your generated {{modalTitle.toLowerCase()}} will be.
    </p>
  }

  <div class="token-cost-highlight">
    This action will consume {{tokenCost}} tokens. Your balance is {{isLoadingBalance ? '...' : tokenBalance?.total}}
  </div>

  @if (isLoadingBalance) {
    <div class="d-flex justify-content-center align-items-center w-100" style="min-height: 150px;">
      <div class="text-center">
        <span class="spinner-border text-light mb-3" role="status" aria-hidden="true"></span>
        <p class="text-light">Loading balance...</p>
      </div>
    </div>
  }

  @if (!isLoadingBalance) {
    <div class="balance-table">
      <div class="balance-row">
        <span class="label">Current Balance:</span>
        <span class="value">{{ tokenBalance?.total }}</span>
      </div>
      <div class="balance-row">
        <span class="label">AI Token Cost:</span>
        <span class="value">{{tokenCost}}</span>
      </div>
      @if (tokenBalance?.total - tokenCost >= 0) {
        <div class="balance-row">
          <span class="label">After Generation:</span>
          <span class="value">{{ tokenBalance?.total - tokenCost }}</span>
        </div>
      }
    </div>
  }

  @if (modalTitle?.toLowerCase() !== 'content') {
    <div class="ai-instruction">
      <label for="aiInstruction" class="ai-instruction-label">Anything to add? <span class="optional">(optional)</span></label>
      <textarea id="aiInstruction" class="ai-instruction-input" rows="3"
        [(ngModel)]="aiInstruction" [maxlength]="aiInstructionMaxLength" [disabled]="isGenerating"
        [placeholder]="modalTitle === 'Backstory' ? 'e.g. she grew up as a thief and is secretly a noble' : modalTitle === 'Description' ? 'e.g. focus on his quiet, watchful manner' : 'e.g. older and battle-worn, standing in the rain'"></textarea>
      <div class="ai-instruction-hint">
        <span>Details on your character sheet always take priority.</span>
        <span>{{ aiInstruction.length }}/{{ aiInstructionMaxLength }}</span>
      </div>
    </div>
  }

<div class="btn-wrapper">
  <button type="button" class="btn btn-outline" (click)="closeModal()" [disabled]="isLoadingBalance">Cancel</button>
  <button type="button" class="btn btn-theme" (click)="handleGenerateToken()"
    [disabled]="isGenerating || isLoadingBalance">
    @if (!isGenerating) {
      OK
    }
    @if (isGenerating) {
      <div class="spinner-border spinner-border-sm text-light me-2"></div>
      Generating...
    }
  </button>
</div>
@if (isGenerating) {
  <p class="description text-center mt-2">
    Note: it takes about 30 seconds...
  </p>
}
</div>